import FeaturePanel from "./features.js"

export default FeaturePanel
